import { useGT } from "gt-react";
import { Cloud, CloudOff, Loader2 } from "lucide-react";
import { useSyncStatusStore } from "../syncStatusStore";
import { useAuthStore } from "../authStore";
import { useAppStore } from "../store";

export function SyncIndicator() {
  const t = useGT();
  const status = useSyncStatusStore((s) => s.status);
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const mode = useAppStore((s) => s.mode);

  // Only show when the signed-in workspace is active
  if (!isAuthenticated || mode !== "signed-in") return null;

  switch (status) {
    case "syncing":
      return (
        <span className="flex items-center gap-1 text-[11px] text-zinc-500" title={t("Syncing...")}>
          <Loader2 size={12} className="animate-spin" />
        </span>
      );
    case "synced":
      return (
        <span className="flex items-center gap-1 text-[11px] text-success" title={t("Synced")}>
          <Cloud size={12} />
        </span>
      );
    case "offline":
      return (
        <span className="flex items-center gap-1 text-[11px] text-warning" title={t("Offline — changes will sync when reconnected")}>
          <CloudOff size={12} />
        </span>
      );
    case "error":
      return (
        <span className="flex items-center gap-1 text-[11px] text-danger" title={t("Sync error")}>
          <CloudOff size={12} />
        </span>
      );
    default:
      return null;
  }
}
